<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Greeting/Message Board</div>
            </div>
            <div class="col-md-2 offset-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Change List Order</button>
            </div>
            <div class="col-md-2 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Add Greeting</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="greetings.columns" :data="greetings.data">
                    <template slot="table-row" v-if="greetings.data.length">
                        <tr v-for="(item, index) in greetings.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.bannerMessage}}</td>
                            <td>{{item.destinationURL}}</td>
                          <td>{{item.corporationName}}</td>
                          <td>{{item.start_dateFmt}}</td>
                          <td>{{item.end_dateFmt}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewGreeting(item)" v-tooltip.top-center="greetings.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editGreeting(item)" v-tooltip.top-center="greetings.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const greetingsColumns = ['Message', 'URL', 'Corporation', 'Start Date/Time', 'End Date/Time', 'Status', 'Operations'];
    export default {
        name: 'Greetings',
        components: {
            LTable,
        },
        data() {
        return {
              greetings: {
                tooltips: {
                    view: 'View Greeting',
                    edit: 'Edit Greeting',
                    delete: 'Inactivate Greeting',
                    activate:'Activate Greeting',
                },
                columns: [...greetingsColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchGreetings () {
            this.$store.dispatch('FETCH_GREETINGS')
                    .then((res) => {
                        this.greetings.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewGreeting(greeting){
            this.$router.push({ name: 'GreetingDetail', params: { id: greeting.bannerId}})
        },
        editGreeting(greeting){
            this.$router.push({ name: 'EditGreeting', params: { id: greeting.bannerId}})
        },
        createGreeting(){
            this.$router.push({ name: 'CreateGreeting'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchGreetings();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Greetings/Greetings.vue